import { render } from "./MaterialsSection.vue?vue&type=template&id=e991134a&scoped=true"
import script from "./MaterialsSection.vue?vue&type=script&lang=js"
export * from "./MaterialsSection.vue?vue&type=script&lang=js"

import "./MaterialsSection.vue?vue&type=style&index=0&id=e991134a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e991134a"]])

export default __exports__